export default __webpack_public_path__ + "static/media/member-icon.7aad0592.svg";